export type FileType = {
  dateModified: string;
  isFile: boolean;
  name: string;
  size: number;
  type: string;
  id?: string;
};

export enum ContextMenuItem {
  MARK_CUSTOMERLIST = 'mark_customerlist',
  UNMARK_CUSTOMERLIST = 'unmark_customerlist',
  // PDF-specific
  MARK_AS_IM = 'mark_as_im',
  MARK_AS_SHAREHOLDER = 'mark_as_shareholder',
  UNMARK_AS_SHAREHOLDER = 'unmark_as_shareholder',
  // Excel-specific
  MARK_AS_XLS_CUSTOMER = 'mark_as_xls_customer',
  UNMARK_AS_XLS_CUSTOMER = 'unmark_as_xls_customer',
  MARK_AS_DA_UPLOAD = 'mark_as_da_upload',
  UNMARK_AS_DA_UPLOAD = 'unmark_as_da_upload',
}
